module.exports = __webpack_public_path__ + "img/02_Screenshot 2025-06-13 at 13.59.03.07bcae0b.jpg";